import api from '@/services/api'
import * as moment from 'moment';
import Vue from 'vue';
import VueI18n from 'vue-i18n'

const LANG_KEY = 'language'

const initLang = (() => {
	return window.localStorage.getItem(LANG_KEY) || window.navigator.language || process.env.VUE_APP_I18N_LOCALE || 'en'
})()

const store = {
	namespaced: true,
	state: {
		config: {},
		registertoken:null,
		calendrierid:null,
		lastchangecalendrierid:null,
		pagetitle: '',
		withSalarieIds: [],
		locale: initLang,
	},
	mutations: {
		setconfig: (state, config) => {
			state.config = config;
		},
		SET_CALENDRIERID: (state, calendrierid) => {
			state.calendrierid = calendrierid;
		},
		SET_LAST_CHANGE_CALENDRIERID: (state, lastchangecalendrierid) => {
			state.lastchangecalendrierid = lastchangecalendrierid;
		},

		SET_WITHSALARIEIDS: (state, values) => {
			state.withSalarieIds = values;
		},
		SET_PAGETITLE: (state, pagetitle) => {
			state.pagetitle = pagetitle;
		},
		SETTOKEN: (state, token) => {
			state.registertoken = token;
		},
		SETLOCALE: (state, locale) => {
			state.locale = locale;
		}
	},
	
	actions: {
		changeLocale({ commit }, locale) {
			commit('SETLOCALE', locale)
			window.localStorage.setItem(LANG_KEY, locale)
		},

		// supprime le token en place
		resetRegisterToken(context) {
			context.commit('SETTOKEN', null);
		},
		setCalendrierId(context, id) {
			context.commit('SET_CALENDRIERID', id);
			context.commit('SET_LAST_CHANGE_CALENDRIERID', moment(new Date()).format("YYYY-MM-DD"));
		},
		setWithSalarieIds(context, id) {
			context.commit('SET_WITHSALARIEIDS', id);
		},
		setPageTitle(context, value) {
			context.commit('SET_PAGETITLE', value);
		},
		async pushregistration(context, token) {
			try {
				let call = await api.post({
					url: 'intervention/pushregistration',
					params: {userid: context.state.config.user.uid, registrationid: token}
				})
				context.commit('SETTOKEN', token);
			} catch (err) {
				console.log('error pushregistration', err);
			}
		},
		reset({commit, state}) {
			commit('SET_CALENDRIERID', null);
			commit('SET_LAST_CHANGE_CALENDRIERID', null);
			commit('SET_WITHSALARIEIDS', []);
		},
		
		async refresh({commit, state}) {
			try {

				let call = await api.get({url: 'intervention/AFCO/config'})
				commit('setconfig', call.response)
				console.log('setconfig', call.response)
				
			} catch (err) {
				console.log('forms refresh', err);
			}
		}
		
		
	},
	getters: {
		isNeedToSelectCalendrierId: function(state){
			return state.calendrierid == null || state.lastchangecalendrierid == null || moment(new Date()).format("YYYY-MM-DD") > state.lastchangecalendrierid
		},
		getConfig: function (state) {
			return state.config;
		},
		getPageTitle: function (state) {
			return state.pagetitle;
		},
		getCalendrierId: function (state) {
			return state.calendrierid;
		},
		withSalarieIds: function (state) {
			return state.withSalarieIds;
		},
		getRegisterToken: function(state) {
			return state.registertoken;
		}
	},
	modules: {}
}

export default store